// extracted by mini-css-extract-plugin
export var askAiIcon = "_pl-9";
export var container = "_pl-0";
export var groupSeparator = "_pl-a";
export var highlight = "_pl-4";
export var resultIcon = "_pl-5";
export var resultItem = "_pl-7";
export var resultSubtitle = "_pl-3";
export var resultTitle = "_pl-2";
export var resultsList = "_pl-1";
export var searchGroup = "_pl-6";
export var selected = "_pl-8";